import { useState } from "react"
import { Alert, Button, Divider, Drawer, Input, Popconfirm, Space, Typography, message } from "antd"
import { CheckCircleOutlined, CloseCircleFilled } from "@ant-design/icons"
import { db } from "../../../../firebase/config"
import { doc, updateDoc } from "firebase/firestore"

const { TextArea } = Input
const { Text } = Typography

export default function RequestStop({ data, firstOpen }) {
  const [open, setOpen] = useState(false)
  const [stopComment, setStopComment] = useState(null)
  const [cancelling, setCancelling] = useState(false)

  const stopRequest = async () => {
    const orderRef = doc(db, "orders", data.id)
    try {
      await updateDoc(orderRef, {
        stopRequestComment: stopComment,
        requestedToStop: true,
      })
    } catch (error) {
      message.error("Something went wrong")
      console.log(error)
    } finally {
      setOpen(false)
      firstOpen(false)
      message.warning("Stop requested!")
    }
  }

  const cancelStopRequest = async () => {
    setCancelling(true)
    const orderRef = doc(db, "orders", data.id)
    try {
      await updateDoc(orderRef, {
        requestedToStop: false,
        stopRequestComment: null,
      })
      message.success("Stop request cancelled.")
      firstOpen(false)
    } catch (error) {
      message.error("Something went wrong")
      console.log(error)
    } finally {
      setCancelling(false)
    }
  }

  if (data.requestedToStop) {
    return (
      <Space direction="vertical" style={{ width: "100%" }}>
        <Alert
          type="warning"
          showIcon
          message="Stop Requested"
          description={
            data.stopRequestComment ? (
              <Text italic>"{data.stopRequestComment}"</Text>
            ) : (
              <Text type="secondary">No reason provided.</Text>
            )
          }
        />
        <Popconfirm
          title="Cancel this stop request?"
          description="The order will resume its normal flow."
          okText="Yes, cancel it"
          cancelText="No"
          onConfirm={cancelStopRequest}>
          <Button
            icon={<CheckCircleOutlined />}
            block
            type="primary"
            loading={cancelling}>
            Cancel Stop Request
          </Button>
        </Popconfirm>
      </Space>
    )
  }

  return (
    <>
      <Button icon={<CloseCircleFilled />} block type="primary" danger onClick={() => setOpen(true)}>
        Request a stop on order
      </Button>

      <Drawer title="Stop Request" width={400} placement="left" onClose={() => setOpen(false)} open={open}>
        <Divider>Why should it be stopped</Divider>
        <Space style={{ width: "100%" }} direction="vertical">
          <TextArea value={stopComment} onChange={(e) => setStopComment(e.target.value)} />
          <Button onClick={stopRequest} block type="primary" danger>
            Request a stop
          </Button>
        </Space>
      </Drawer>
    </>
  )
}
